import { render, staticRenderFns } from "./myCollection.vue?vue&type=template&id=18ee92ae&scoped=true&"
import script from "./myCollection.vue?vue&type=script&lang=js&"
export * from "./myCollection.vue?vue&type=script&lang=js&"
import style0 from "./myCollection.vue?vue&type=style&index=0&id=18ee92ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee92ae",
  null
  
)

export default component.exports